import Vue from 'vue'
import ElementUI, { Dialog, MessageBox } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'
import store from './store'
import './assets/styles/index.scss'

// 弹框只能通过按钮主动关闭，禁止点击遮罩层或按 ESC 关闭
Dialog.props.closeOnClickModal.default = false
Dialog.props.closeOnPressEscape.default = false
MessageBox.setDefaults({
  closeOnClickModal: false,
  closeOnPressEscape: false
})

Vue.use(ElementUI, { size: 'small' })
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
